import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css'],
})
export class SearchInputComponent implements OnInit {

  @Input()
  search = '';
  @Output() onSearch: EventEmitter<string> = new EventEmitter();
  @Output() onSearchKeyUp: EventEmitter<string> = new EventEmitter();

  @Input() showButton: boolean = false; // CR requested by Kester

  constructor() {}

  ngOnInit() {}

  onHandleSearch() {
    this.onSearch.emit(this.search);
  }

  onSearchKeypress(event) {
    this.onHandleSearch();
  }
  focusOutSearch(){
    this.onSearchKeyUp.emit(this.search);
  }

  onSearchDbKeyUp(e) {
    this.onSearchKeyUp.emit(this.search);
  }

  reset() {
    this.search = '';
  }
}
